import { render, staticRenderFns } from "./CbsActions.vue?vue&type=template&id=2e68c020&scoped=true"
import script from "./CbsActions.vue?vue&type=script&lang=js"
export * from "./CbsActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e68c020",
  null
  
)

export default component.exports